/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import ReactGA from "react-ga4";
import config from "../config/vars";

const enableCondition = "YES";

export const initialize = () => {
  if (config.enableGA === enableCondition) {
    ReactGA.initialize(config.accountGA);
  }
};

export const fireEvent = (category, action, label, value) => {
  if (config.enableGA === enableCondition) {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
  }
};

export const usePageView = path => {
  useEffect(() => {
    if (config.enableGA === enableCondition) {
      if (path) {
        ReactGA.send({ hitType: "pageview", page: path });
      } else {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
      }
    }
  }, []);
};

export default { initialize, fireEvent, usePageView };
